import React, { useState } from 'react';
import styled from '@emotion/styled';

const durations = [
    { label: '15', value: 15 },
];

const DurationGrid = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
`;

const DurationCard = styled.div`
  width: ${props => (props.custom ? '193px' : '98px')};
  height: 66px;
  background: ${props => props.selected ? '#EDEDED' : '#363636'};
  color: ${props => props.selected ? '#1C1C1C' : '#EDEDED'};
  border-radius: 8px;
  border: 1px solid ${props => props.selected ? '#EDEDED' : 'transparent'};
  box-shadow: ${props => props.selected ? '0px 1px 15px rgba(69, 65, 78, 0.08)' : 'none'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: 'Clash Grotesk', sans-serif;
  font-size: 14px;
  font-weight: 400;
  position: relative;
`;

const DurationValue = styled.div`
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  color: inherit;
`;

const DurationLabel = styled.div`
  font-size: 14px;
  color: inherit;
`;

const CustomInput = styled.input`
  width: 60px;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #ededed;
  background: #151414;
  color: #ededed;
  font-family: 'Clash Grotesk', sans-serif;
  font-size: 14px;
  text-align: center;
  margin-top: 4px;
`;

function TestDriveDuration({ value, onChange }) {
    const [custom, setCustom] = useState('');
    return (
        <div>
            <div style={{ color: '#EDEDED', fontSize: 18, fontFamily: 'Clash Grotesk', fontWeight: 500 }}>Duration of test drive</div>
            <DurationGrid>
                {[{ value }].map((d, i) => (
                    <DurationCard
                        key={d.value}
                        selected={value === d.value || (d.value === 'custom' && value && ![15, 45, 60].includes(value))}
                        custom={d.value === 'custom'}
                    >
                        <DurationValue>{d.value === 'custom' ? (custom ? custom : '_') : d.value}</DurationValue>
                        <DurationLabel>mins</DurationLabel>
                        {d.value === 'custom' && (
                            <CustomInput
                                type="number"
                                min={1}
                                placeholder="custom"
                                value={custom}
                                onClick={e => e.stopPropagation()}
                                onChange={e => {
                                    setCustom(e.target.value);
                                    onChange(Number(e.target.value));
                                }}
                            />
                        )}
                    </DurationCard>
                ))}
            </DurationGrid>
        </div>
    );
}

export default TestDriveDuration;